module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAABNElEQVQokX3Sv6vNcRgH8Nc5nSLZrslgkkhh8R+8MyiDQYpN6WYzYhaDMpKBFGUgC4P6PDk3ksV0ZaHEZLmMh4E+Bt+r06HzLM+v97t3z49Ra+0iTuAnuuU2whY8nOAKDuPL0Pif/UiyUVU7sR2vJ/iIfUneLJOqqtUkt6pqL2ZjnMPdqtq6hPQSF4Z0iut671pr09ba0yHe31rb1nvf7K211voQn2+tfe69G/XeVdUKNrBrmPfe4K/hKFbwHTMcTLI+hiRfcQnPkzzGK7wbSAeSfMMLPEiyDuPNOZJcxY6qOpvkCD7gTJK3VXUMh3B6Ez9Z2MNxTKvqdpI9c/VHWE3y987jeVaSNTzBs7mN3sCnJHfmsYuKcBKzqjqF9/6ca/ciaNT7v19WVcFN/MLlJPcXMb8B7XyHjWEErAYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/34.png
// module id = 1aC+
// module chunks = 0